import { create } from 'zustand';

import { Platform } from '@/data/models/platform.interface';

export interface PlatformState {
  platforms: Platform[];
  selectedPlatform: Platform | null;
  isLoading: boolean;
  error: string | null;
  setPlatforms: (_platforms: Platform[]) => void;
  setSelectedPlatform: (_platform: Platform | null) => void;
  setLoading: (_isLoading: boolean) => void;
  setError: (_error: string | null) => void;
  clearPlatforms: () => void;
  hasPlatform: (_platformName: string) => boolean;
}

const usePlatformStore = create<PlatformState>((set, get) => ({
  platforms: [],
  selectedPlatform: null,
  isLoading: false,
  error: null,

  setPlatforms: (platforms: Platform[]) => {
    set({ platforms, error: null });
    if (platforms.length === 1) {
      set({ selectedPlatform: platforms[0] });
    }
  },

  setSelectedPlatform: (platform: Platform | null) => {
    set({ selectedPlatform: platform });
  },

  setLoading: (isLoading: boolean) => {
    set({ isLoading });
  },

  setError: (error: string | null) => {
    set({ error, isLoading: false });
  },

  clearPlatforms: () => {
    set({
      platforms: [],
      selectedPlatform: null,
      error: null,
      isLoading: false,
    });
  },

  hasPlatform: (platformName: string) => {
    const state = get();
    return state.platforms.some(
      (platform) => platform.value.toLowerCase() === platformName.toLowerCase(),
    );
  },
}));

export default usePlatformStore;
